<template>
  <div>
    <div v-if="loading" class="overlay">
      <div><img class="spinner" src="loading.gif" alt="Loading data..." /></div>
    </div>

    <div v-else-if="isolatedState === 0">
      <h1 style="text-transform: uppercase; text-align: left">
        Emissão Ato Isolado
      </h1>
      <div class="button-container" id="container-contact">
        <div class="container">
          <div class="row align-items-center">
            <div class="message-section" id="align-center">
              <div class="flex-container-emissao" id="no-pad-left">
                <h2 class="close-request">Requisições fechadas</h2>
                <img
                  src="img/requisicoes_fechadas.png"
                  alt="Fechado"
                  class="icon-size-submition"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else-if="
        $auth.check(['dashboard.accounts']) && dsr_payment_method === 2
      "
    >
      <!-- Dados sobre Pontos -->
      <div id="movpoints">
        <h1 style="text-transform: uppercase; text-align: left">
          Emissão Ato Isolado
        </h1>
        <div class="card-list">
          <div class="card">
            <div class="card-content">
              <h4
                style="
                  margin-bottom: 0;
                  background-color: #f48c4f;
                  color: white;
                  padding: 12px;
                  border-radius: 10px;
                  max-width: 75%;
                "
              >
                Ano correspondente: {{ lastYear }}
              </h4>

              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  margin-top: 20px;
                  margin-bottom: 0;
                  height: 20px;
                "
              >
                <p style="font-weight: bold">Pontos UFS:</p>
                <p style="font-weight: bold">{{ points.ufs.original }}</p>
              </div>

              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  margin-bottom: 0;
                  height: 20px;
                "
              >
                <p style="font-weight: bold">Pontos OLA:</p>
                <p style="font-weight: bold">{{ points.ola.original }}</p>
              </div>

              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  margin-bottom: 0;
                  height: 20px;
                  margin-top: 20px;
                "
              >
                <p>Total:</p>
                <p style="font-weight: bold; color: #f48c4f">
                  {{ totalPoints }}
                </p>
              </div>

              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  margin-bottom: 0;
                  height: 20px;
                "
              >
                <p></p>
                <p style="font-size: 14px">equivalente a {{ totalValue }}€</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Modal de Contato -->
      <div class="button-container" v-if="isolatedState === 1">
        <div class="intro">
          <h2 style="text-transform: uppercase; text-align: left">
            Envio do comprovativo
          </h2>
        </div>

        <div class="contact-container" id="container-contact">
          <div v-if="zoneStatus === 'ok'">
            <!-- Message Section -->
            <div class="container">
              <div class="row align-items-center">
                <!-- Message Section -->
                <div class="col-md-10 col-10">
                  <div class="message-section">
                    <h2 style="font-size: 18px">
                      Estado:
                      <strong :class="getClass(state.estado)">
                        <button
                          v-if="submissionStateCode === null"
                          style="
                            background-color: #fff;
                            color: #000;
                            border: none;
                            padding: 10px 20px;
                            font-size: 14px;
                            display: inline-flex;
                            position: absolute;
                            right: -40px;
                            top: -4px;
                            align-items: center;
                            border-radius: 5px;
                          "
                        >
                          Não submetido
                        </button>
                        <button
                          v-if="state.estado === 'Em Aprovação'"
                          style="
                            background-color: #fff;
                            color: #000;
                            border: none;
                            padding: 10px 20px;
                            font-size: 14px;
                            display: inline-flex;
                            position: absolute;
                            right: -40px;
                            top: -4px;
                            align-items: center;
                            border-radius: 5px;
                          "
                        >
                          <!-- Check icon for 'Aprovado' -->
                          <!--<i class="fa fa-check-circle" style="font-size: 30px; margin-right: 10px;"></i>-->
                          Em Aprovação
                        </button>
                        <button
                          v-if="state.estado === 'Substituído'"
                          style="
                            background-color: #fff;
                            color: orange;
                            border: none;
                            padding: 10px 20px;
                            font-size: 14px;
                            display: inline-flex;
                            position: absolute;
                            right: -40px;
                            top: -4px;
                            align-items: center;
                            border-radius: 5px;
                          "
                        >
                          <!-- Check icon for 'Aprovado' -->
                          <!--<i class="fa fa-check-circle" style="font-size: 30px; margin-right: 10px;"></i>-->
                          Substituído
                        </button>
                        <button
                          v-if="state.estado === 'Aprovado'"
                          style="
                            background-color: #fff;
                            color: #4caf50;
                            border: none;
                            padding: 10px 20px;
                            font-size: 14px;
                            display: inline-flex;
                            position: absolute;
                            right: -40px;
                            top: -4px;
                            align-items: center;
                            border-radius: 5px;
                          "
                        >
                          <!-- Check icon for 'Aprovado' -->
                          <!--<i class="fa fa-check-circle" style="font-size: 30px; margin-right: 10px;"></i>-->
                          Aprovado
                        </button>

                        <button
                          v-if="state.estado === 'Rejeitado'"
                          style="
                            background-color: #fff;
                            color: #ff0004;
                            border: none;
                            padding: 10px 20px;
                            font-size: 14px;
                            display: inline-flex;
                            position: absolute;
                            right: -40px;
                            top: -4px;
                            align-items: center;
                            border-radius: 5px;
                          "
                        >
                          <!-- Check icon for 'Aprovado' -->
                          <!--<i class="fa fa-times-circle" style="font-size: 30px; margin-right: 10px;"></i>-->
                          Rejeitado
                        </button>
                      </strong>

                      <!-- Show icon based on status -->
                    </h2>
                    <br />
                    <h2 v-if="submissionStateCode === '2'" class="button-pad">
                      Motivo: {{ print_message }}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <!-- submission Button -->
            <div class="button-container message-section">
              <button
                v-if="
                  submissionStateCode === '0' || submissionStateCode === '1'
                "
                @click="openModal"
                class="btn btn-primary"
                style="display: none"
              ></button>

              <div
                v-else-if="submissionStateCode === '2'"
                class="flex-container-emissao"
              >
                <div class="text"><strong>Submeter Novo Recibo</strong></div>
                <button @click="openModal" class="btn icon-button">
                  <img
                    src="img/submit_button.png"
                    alt="Submeter"
                    class="icon-size-submition"
                  />
                </button>
              </div>

              <div
                v-else-if="submissionStateCode === '3'"
                class="flex-container-emissao"
              >
                <div class="text"><strong>Aguarda nova aprovação</strong></div>
              </div>

              <div v-else class="flex-container-emissao">
                <div class="text">Submeter Recibo</div>
                <button @click="openModal" class="btn icon-button">
                  <img
                    src="img/submit_button.png"
                    alt="Submeter"
                    class="icon-size-submition"
                  />
                </button>
              </div>
            </div>
          </div>
          <div v-else>
            <div
              style="
                padding: 12px;
                margin-bottom: 10px;
                display: flex;
                justify-content: space-between;
                align-items: center;
              "
            >
              <p
                style="
                  font-weight: bold;
                  margin: 0;
                  font-size: medium;
                  color: #fff;
                "
              >
                {{ zoneName || "-" }}
              </p>

              <p
                style="
                  font-weight: bold;
                  margin: 0;
                  color: #fff;
                  background: #b40004;
                  padding: 12px;
                  border-radius: 10px;
                "
              >
                Estado: {{ zoneStatus ? zoneStatus.toUpperCase() : "-" }}
              </p>
            </div>
            <p style="color: #fff; padding: 0px 10px 20px 10px">
              A sua zona ainda não se encontra aprovada. Por favor confira com o
              seu responsável de equipa.
            </p>
          </div>
        </div>
      </div>
      <div v-else class="button-container" id="container-contact">
        <div class="container">
          <div class="row align-items-center">
            <div class="message-section" id="align-center">
              <h2 class="close-request">Requisições fechadas</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- form Modal -->
    <div
      id="form-contact"
      class="modal-overlay"
      v-if="isModalOpen"
      @click="closeModal"
    >
      <div class="modal-content" @click.stop>
        <h2>Envio de comprovativo</h2>
        <div v-if="submissionStateCode === '2'" class="modal-body">
          <form @submit.prevent="updateRescueReceipt">
            <div class="border-box">
              <label for="name">NOME</label>
              <div class="form-nome">{{ user }}</div>
              <!-- Display the name parameter -->
            </div>
            <div class="form-group">
              <textarea
                v-model="message"
                placeholder="Nome do Documento"
                class="form-control form-name"
              ></textarea>
            </div>
            <div class="form-group">
              <label for="fileUpload" class="btn btn-primary">
                {{ fileName ? "Selecionar anexo" : "ANEXAR COMPROVATIVO" }}
              </label>
              <input
                id="fileUpload"
                type="file"
                @change="handleFileUpload"
                class="hidden-file-input"
                accept="image/*"
                style="display: none"
              />
              <!-- Display selected file name if available -->
              <p v-if="fileName" class="file-name">{{ fileName }}</p>
              <button
                v-if="fileName"
                class="btn-delete btn-sm mt-2"
                @click="deleteFile"
              >
                Remover anexo</button
              ><br />
            </div>
            <div class="form-group">
              <div class="container">
                <div class="row">
                  <!-- "Cancelar" Button Column -->
                  <div class="col-6">
                    <button
                      class="close-btn btn btn-secondary"
                      @click="closeModal"
                    >
                      CANCELAR
                    </button>
                  </div>
                  <!-- "Enviar" Button Column -->
                  <div class="col-6 text-right">
                    <button type="submit" class="btn btn-primary">
                      Submeter novo recibo
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div v-else class="modal-body">
          <form @submit.prevent="submitRescue">
            <div class="border-box">
              <label for="name">NOME</label>
              <div class="form-nome">{{ user }}</div>
              <!-- Display the name parameter -->
            </div>
            <div class="form-group">
              <textarea
                v-model="message"
                placeholder="Nome do Documento"
                class="form-control form-name"
              ></textarea>
            </div>
            <div class="form-group">
              <label for="fileUpload" class="btn btn-primary">
                {{ fileName ? "Selecionar anexo" : "ANEXAR COMPROVATIVO" }}
              </label>
              <input
                id="fileUpload"
                type="file"
                @change="handleFileUpload"
                class="hidden-file-input"
                accept="image/*"
                style="display: none"
              />
              <!-- Display selected file name if available -->
              <p v-if="fileName" class="file-name">{{ fileName }}</p>
              <button
                v-if="fileName"
                class="btn-delete btn-sm mt-2"
                @click="deleteFile"
              >
                Remover anexo</button
              ><br />
            </div>
            <div class="form-group">
              <div class="container">
                <div class="row">
                  <!-- "Cancelar" Button Column -->
                  <div class="col-6">
                    <button
                      class="close-btn btn btn-secondary"
                      @click="closeModal"
                    >
                      CANCELAR
                    </button>
                  </div>
                  <!-- "Enviar" Button Column -->
                  <div class="col-6 text-right">
                    <button type="submit" class="btn btn-primary">
                      Submeter recibo
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Feedback Modal -->
    <div
      id="feedback-modal"
      class="modal-overlay"
      v-if="isFeedbackModalOpen"
      @click="closeFeedbackModal"
    >
      <div class="modal-content" @click.stop>
        <p>{{ feedbackMessage }}</p>
        <button class="btn btn-primary" @click="closeFeedbackModal">OK</button>
      </div>
    </div>
  </div>
</template>

<script src="https://cdn.jsdelivr.net/npm/vue@2.6.14/dist/vue.js"></script>
<script>
import axios from "axios"; // Import axios here
import Vue from "vue";
import VModal from "vue-js-modal";
import "vue-js-modal/dist/styles.css";

Vue.use(VModal);

export default {
  name: "emissao",
  components: {},
  data() {
    return {
      previousYear: new Date().getFullYear() - 1, // gives the previous year
      lastYear: null,
      points: {
        ufs: { headers: [], original: 0, exception: null },
        ola: { headers: [], original: 0, exception: null },
      },
      state: {
        estado: "Não Submetido",
      },
      zoneName: null,
      zoneStatus: null,
      submissionStateCode: null,
      isolatedState: null,
      showModal: false,
      isModalOpen: false,
      isFeedbackModalOpen: false,
      feedbackTitle: "",
      feedbackMessage: "",
      image: null,
      data: null,
      loading: true,
      user: null,
      points: null,
      fileName: "", // Track the file name
      docs: null,
      hasLoadedMore: false,
      isLeader: false,
      user_id: null,
      dsr_id: null,
      dsr_payment_method: null,
      uploadedFile: null,
    };
  },

  computed: {
    totalPoints() {
      return (
        ((this.points && this.points.ufs && this.points.ufs.original) || 0) +
        ((this.points && this.points.ola && this.points.ola.original) || 0)
      );
    },

    totalValue() {
      let total = 0.01 * this.totalPoints;
      let rounded = total.toFixed(2);
      return rounded;
    },
  },

  async mounted() {
    try {
      this.loading = true;
      await Promise.all([
        this.fetchPointsActoIsolado(),
        this.fetchZoneDsrStatus(),
        this.fetchSubmissionState(),
        this.closeRequest(),
        this.fetchDsrId(),
        this.fetchName(),
        this.formatName(),
      ]);
      this.loading = false;
    } catch (error) {
      console.error("Error during initialization:", error);
      this.loading = false;
    }
  },

  methods: {
    async closeRequest() {
      this.loading = true;
      this.isolatedState = null;

      try {
        const response = await axios.get(`app/checkIsolated`);
        const dataArray = response.data;

        // Check if data array is not empty
        if (dataArray.length > 0) {
          const lastElement = dataArray[dataArray.length - 1];
          console.log("is valid:", lastElement.is_valid);
          this.isolatedState = lastElement.is_valid;
        } else {
          console.log("No data returned");
        }
      } catch (error) {
        console.error("Error fetching closing time:", error);
      }
    },

    async fetchPointsActoIsolado() {
      try {
        const response = await axios.get(`app/getIsolatedLast`);

        if (response.status === 200 && response.data) {
          const { ufs, ola, lastYear } = response.data;

          // Validate the structure before assigning
          this.points = {
            ufs: ufs || { headers: [], original: 0, exception: null },
            ola: ola || { headers: [], original: 0, exception: null },
          };
          this.lastYear = lastYear || null;
        } else {
          console.error("Failed to fetch data:", response);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    async fetchSubmissionState() {
      this.submissionStateCode = null;
      this.print_message = null;
      try {
        const response = await axios.get(`/app/getStatusIsolatedLast`);
        if (
          response.status === 200 &&
          Array.isArray(response.data) &&
          response.data.length > 0
        ) {
          // Take the last element of the array
          const lastEntry = response.data[response.data.length - 1];
          this.submissionStateCode = lastEntry.status_code;
          this.state = {
            estado: lastEntry.status_description || "Sem registros",
          };
          this.print_message = lastEntry.print_message;
        } else {
          // Handle cases where data is empty or not an array
          this.state = { estado: "Não Submetido" };
        }
      } catch (error) {
        // Log a warning or handle the case gracefully
        console.warn("No submission data available:", error);
        this.state = { estado: "Não Submetido" };
      }
    },

    getClass(status) {
      switch (status) {
        case "Em Aprovação":
          return "text-confirmation";
        case "Rejeitado":
          return "text-danger";
        case "Aprovado":
          return "text-success";
        case "Substituído":
          return "text-replaced";
        default:
          return "text-warning";
      }
    },

    formatName(fullName) {
      if (!fullName) return ""; // Retorna vazio se o nome não existir
      const names = fullName.trim().split(" ");
      if (names.length === 1) return names[0]; // Apenas um nome
      return `${names[0]} ${names[names.length - 1]}`; // Primeiro e último
    },

    getRunningBalance(index) {
      // Start with saldoOla as the base
      let balance = this.saldo;

      // Sum the total_points up to the current index
      for (let i = this.sortedPointsData.length - 2; i >= index; i--) {
        balance += parseFloat(this.sortedPointsData[i].total_points);
      }

      return balance;
    },
    getImageUrl(imageUrl) {
      // Check if the image URL is valid
      return imageUrl ? imageUrl : this.defaultImage();
    },

    defaultImage() {
      // Return the path to the default image
      return "default-product.png";
    },
    handleImageError(event) {
      event.target.src = "default-product.png";
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    openFeedbackModal(title, message) {
      this.feedbackTitle = title;
      this.feedbackMessage = message;
      this.isFeedbackModalOpen = true;
    },
    triggerFileInput(event) {
      // Prevent default behavior and manually trigger the file input click
      event.stopPropagation();
      this.$refs.fileInput.click();
    },

    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        // Validate file type
        if (!file.type.startsWith("image/")) {
          alert("Please select a valid image file.");
          this.file = null;
          this.image = null;
          return;
        }

        // Create a URL for the selected file for preview
        this.image = URL.createObjectURL(file);
        // Store the file object for submission
        this.file = file;
      } else {
        // Reset the image and file if no file is selected
        this.image = null;
        this.file = null;
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        console.log("File selected:", file);
        console.log("File name:", file.name);
        console.log("File type:", file.type);
        console.log("File size (bytes):", file.size);
        this.image = file;
        this.fileName = file.name;
      } else {
        this.fileName = "";
      }
    },

    deleteFile() {
      this.fileName = ""; // Clear the file name
      this.image = null; // Clear the image property

      // Reset the file input field (optional)
      const fileInput = document.getElementById("fileUpload");
      if (fileInput) {
        fileInput.value = "";
      }
    },

    async submitRescue() {
      const formData = new FormData();
      if (this.message) {
        formData.append("receipt_number", this.message);
      }
      // Attach the file only if it exists
      if (this.image) {
        formData.append("image", this.image);
      }
      if (this.points && this.points.ufs && this.points.ola) {
        formData.append("points_ufs", this.points.ufs.original);
        formData.append("points_ola", this.points.ola.original);
        // formData.append('user_id', this.user_id);
        formData.append("dsr_id", this.dsr_id);
      }

      try {
        const response = await axios.post(
          `app/createIsolated/${this.points.ufs.original},${this.points.ola.original}`,
          formData
        );

        console.log("Response from server:", response);

        if (response.data.success) {
          this.showFeedbackModal(
            "Sucesso",
            "Comprovativo submetido com sucesso"
          );
          this.closeModal();
        } else {
          this.showFeedbackModal(
            "Erro",
            "Erro ao enviar o seu comprovativo. Tente novamente!"
          );
        }
        this.clearFormData();
      } catch (error) {
        console.error("Erro ao enviar o seu comprovativo:", error);
        if (error.response) {
          console.error("Error response data:", error.response.data);
          console.error("Error response status:", error.response.status);
          console.error("Error response headers:", error.response.headers);
          this.clearFormData();
        }
        this.showFeedbackModal(
          "Erro",
          "Ocorreu um erro ao enviar o seu comprovativo. Verifique se carregou o documento e o nome do mesmo"
        );
        this.clearFormData();
      }

      if (response.data.success) {
        console.log("Submission successful.");
        this.showFeedbackModal("Sucesso", "Submission message...");
      } else {
        console.log("Submission failed.");
        this.showFeedbackModal("Erro", "Error message...");
      }
    },

    async updateRescueReceipt() {
      if (!this.message || !this.image) {
        this.showFeedbackModal(
          "Erro",
          "Deve inserir o nome do documento e anexar o comprovativo."
        );
        return;
      }

      const formData = new FormData();
      if (this.message) {
        formData.append("receipt_number", this.message);
      }
      // Attach the file only if it exists
      if (this.image) {
        formData.append("image", this.image);
      }
      if (this.points && this.points.ufs && this.points.ola) {
        formData.append("points_ufs", this.points.ufs.original);
        formData.append("points_ola", this.points.ola.original);
        // formData.append('user_id', this.user_id);
        formData.append("dsr_id", this.dsr_id);
      }

      try {
        const response = await axios.post(`app/updateProof`, formData);

        console.log("Response from server:", response);

        if (response.data.success) {
          this.showFeedbackModal("Sucesso", "Resgate atualizado com sucesso");
          this.closeModal();
        } else {
          this.showFeedbackModal(
            "Erro",
            "Erro ao enviar o seu comprovativo. Tente novamente!"
          );
        }
        this.clearFormData();
      } catch (error) {
        console.error("Erro ao enviar o seu comprovativo:", error);
        if (error.response) {
          console.error("Error response data:", error.response.data);
          console.error("Error response status:", error.response.status);
          console.error("Error response headers:", error.response.headers);
          this.clearFormData();
        }
        this.showFeedbackModal(
          "Erro",
          "Ocorreu um erro ao enviar o seu comprovativo. Verifique se carregou o documento e o nome do mesmo"
        );
        this.clearFormData();
      }
    },

    showFeedbackModal(title, message) {
      this.feedbackTitle = title;
      this.feedbackMessage = message;
      this.isFeedbackModalOpen = true;
    },

    closeFeedbackModal() {
      this.isFeedbackModalOpen = false;
      console.log("Feedback modal closed. Fetching submission state...");
      this.fetchSubmissionState();
    },

    clearFormData() {
      this.message = "";
      this.image = null;
      this.fileName = "";
    },

    fetchDsrId() {
      this.loading = true;
      this.error = null;
      this.dsr_id = null;
      this.dsr_payment_method = null;

      this.axios
        .get("app/getDsrId")
        .then((response) => {
          // Assuming response.data contains the object with the name field
          this.dsr_id = response.data.dsr_id;
          this.dsr_payment_method = response.data.payment_method;
          this.loading = false;
        })
        .catch((error) => {
          this.error = error.message;
          this.loading = false;
        });
    },

    fetchName() {
      this.loading = true;
      this.error = null;
      this.user = null;
      this.user_id = null;

      this.axios
        .get("app/getInfo")
        .then((response) => {
          // Assuming response.data contains the object with the name field
          this.user = response.data.name;
          this.user_id = response.data.user;
          this.loading = false;
        })
        .catch((error) => {
          this.error = error.message;
          this.loading = false;
        });
    },

    async fetchZoneDsrStatus() {
      try {
        const response = await axios.get("app/getZoneDsrStatus");

        if (!response.data) return;

        this.zoneName = response.data.zone_name || null;
        this.zoneStatus = response.data.status || null;
      } catch (error) {
        console.error("Error fetching zone DSR status:", error);
      }
    },
  },
};
</script>

<style>
.icon-size-submition {
  width: 40px;
}

.flex-container-emissao {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding-left: 15px;
}

#no-pad-left {
  padding-left: 0px;
  padding-bottom: 15px;
}

.text {
  flex-grow: 1;
  text-align: left;
  color: #fff;
  font-size: 18px;
}

.icon img {
  width: 40px;
}

p {
  font-size: 18px;
}

.spinner {
  width: 80px;
  height: 80px;
  text-align: center;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  /* 50% opacity grey */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* Make sure it's on top of everything */
}

.text-confirmation {
  color: orange;
}

.text-danger {
  color: red;
}

.text-success {
  color: green;
}

.text-replaced {
  color: rgb(0, 255, 255);
}

.text-warning {
  color: orange;
}

.bold {
  font-weight: 500;
}

.error {
  color: red;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: 30px 0px 10px 0px;
  scrollbar-width: none !important;
  /* Oculta a barra de rolagem */
}

#app::-webkit-scrollbar {
  display: none !important;
  /* Para Chrome, Safari e outros navegadores baseados em WebKit */
}

#form-contact .form-group {
  margin-bottom: 15px;
}

.points-container {
  display: flex;
}

#form-contact .form-name {
  width: 100%;
  /* padding: 10px; */
  font-size: 14px;
  min-height: 5vh;
  max-height: 5vh;
}

#form-contact .form-anexo {
  width: 100%;
  padding: 10px;
  font-size: 14px;
  height: auto;
  min-height: 2vh;
}

#form-contact .btn {
  padding: 10px 20px;
  font-size: 14px;
}

#form-contact .btn-delete {
  color: white;
  background-color: red;
  border: 0px;
  border-radius: 4px;
  font-size: 14px;
}

#form-contact .form-nome {
  margin-top: -10px;
}

#form-contact .modal-container {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  max-width: 500px;
  width: 90%;
  margin: auto;
}

#form-contact .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#form-contact .modal-title {
  margin: 0;
}

#form-contact .close {
  cursor: pointer;
}

#form-contact .modal-body {
  padding: 0 0;
  padding-top: 20px;
}

#form-contact h2 {
  font-size: 16px;
  margin-top: 5px;
}

#align-center {
  text-align: left;
}

.close-request {
  font-size: 18px !important;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

#form-contact .modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  position: relative;
  max-width: 500px;
  width: 90%;
  margin: auto;
}

#form-contact .close-btn {
  color: #c26e00;
  border: none;
  /* display: flex; */
  justify-content: center;
  align-items: center;
  background: none;
  cursor: pointer;
}

#form-contact .custom-file-upload {
  position: relative;
  display: inline-block;
}

#form-contact .custom-file-upload input[type="file"] {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

#form-contact .border-box {
  border: 1px solid #e4e7ea;
  border-radius: 5px;
  padding: 10px;
  /*background-color: #f8f9fa;*/
  margin-bottom: 20px;
  font-size: 16px;
}

#form-contact .custom-file-upload label {
  cursor: pointer;
  display: inline-block;
  width: 100%;
  text-align: center;
}

.intro h2 {
  font-size: 16px;
  margin-top: 20px;
  margin-bottom: 10px;
}

#movpoints .card {
  /* width: 300px; */
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  background-color: #f9f9f9;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

#movpoints .card-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

#movpoints .card-list {
  display: block;
  width: 100%;
}

#container-contact {
  background: linear-gradient(240.74deg, #c26e00 0%, #af3f00 100%);
  border-radius: 15px;
  padding-top: 20px;
  padding-left: 5px;
  padding-right: 5px;
}

#container-contact .contact-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}

#container-contact .message-section {
  flex: 1;
  /*padding-right: 20px;*/
  padding: 5px 5px 5px 5px;
}

#container-contact .image-section {
  /*flex: 0.3;
  text-align: right;*/
  width: max-content;
}

#container-contact .image-section img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

#container-contact .btn-primary {
  background-color: #fff;
  color: #f48c4f;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  border-radius: 10px;
}

#container-contact .btn-primary:hover {
  background-color: #f48c4f;
  color: #fff;
}

#form-contact .btn-primary {
  background-color: #f48c4f;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  width: 100%;
}

#form-contact .custom-file-upload {
  position: relative;
  display: inline-block;
}

#form-contact .custom-file-upload input[type="file"] {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}

#form-contact .custom-file-upload label {
  cursor: pointer;
  display: inline-block;
  width: 100%;
  text-align: center;
}

#form-contact .btn-primary:hover {
  background-color: #c26e00;
  color: #fff;
}

#container-contact h2 {
  color: #fff;
  font-size: 16px;
}

#container-contact p {
  color: #666;
  font-size: 16px;
}

#container-contact .button-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

#form-feedback .modal-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  max-width: 400px;
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

#form-feedback .modal-content h2 {
  margin-top: 0;
}

#form-feedback .btn {
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #f48c4f;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

#form-feedback .btn:hover {
  background-color: #c26e00;
  color: #fff;
}

#download .title {
  margin-top: 20px;
  margin-bottom: 20px;
}

#download .btn-primary {
  background-color: #fff;
  color: #c26e00;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  text-align: center;
  width: 60%;
  margin-top: 30px;
  text-transform: uppercase;
  margin-left: 20%;
  margin-right: 20%;
  margin-bottom: 30px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  /* 50% opacity grey */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  /* Make sure it's on top of everything */
}

#download .btn-primary:hover {
  background-color: #f48c4f;
  color: #fff;
}

/* @media (max-width: 767px) {
  body {
    overflow-y: auto !important;
    height: 100vh; 
    scrollbar-width: none !important; 
  }
  
  body::-webkit-scrollbar {
    display: none !important; 
  }
} */
.red {
  color: red;
}

.green {
  color: #00c939;
}

.yellow {
  color: orange;
}

body {
  margin: 0;
  padding: 0;
  height: 100vh;
  /* Garante que ocupe toda a altura da tela */
}
</style>
